import { axiosClient } from '../../../library/Service/axiosClient';
import ProfileLevelSyncConfig from './ProfileLevelSyncConfig.json'

class ProfieLevelSyncService {
    static pageLoader(params: any): Promise<any> {
        const state: any = {};
        const searchCriteria = this.getDefaultSearchCriteria();

        return Promise.all([
            this.getPageConfig(),
            this.search(searchCriteria, params.pageName),
        ]).then((values) => {
            state.formConfig = values[0];
            state.data = {
                alumniList: values[1].data ?? [],
                searchCriteria: { ...searchCriteria, schoolId: sessionStorage.getItem('user-school-id') },
            };
            state.routeInfo = params;
            state.internal = { gridState: {} };
            return Promise.resolve(state);
        });
    }

    static search(searchCriteria: any, reportType: string): any {
        const payload = ProfieLevelSyncService.sanitizeSearchCriteria(searchCriteria, reportType);
        return axiosClient().post(`${process.env.REACT_APP_INTERNAL_ADMIN_SERVER}/search/institute-profile-level-sync`, payload);
    }

    static getPageConfig() {
        return Promise.resolve(ProfileLevelSyncConfig);
    }

    // Notes: This is key function in forming the search criteria for the report. Handle with care.
    static sanitizeSearchCriteria(searchCriteria: any, reportType: string) {
        return searchCriteria;
    }

    static getDefaultSearchCriteria(): any {
        return {
            domainCategory: [],
        };
    }
}

export default ProfieLevelSyncService;
